import styled, { createGlobalStyle } from 'styled-components';
import { rgba } from '../../utils/polished';
import { IProps, ModalVariation } from './Modal';

export const ModalGlobalStyle = createGlobalStyle`
  .underlay {
    background-color: ${rgba('black', 0.75)};
    opacity: 0;
    transition: opacity 0.2s ease-in;
  }

  .underlay--open {
    opacity: 1;
  }

  .underlay--no-click {
    cursor: default!important;
  }
`;

export const ModalElement = styled.div<IProps>`
  margin: 2rem 0;
  padding: 24px 0;
  transition: opacity 0.1s ease-in, transform 0.1s ease-in;
  transition-delay: 0.2s;
  transform: ${({ isOpen }) => (isOpen ? 'scale(1) translateY(0)' : 'scale(1.1) translateY(10%)')};
  display: grid;
  grid-template-areas: 'header' 'content';
  grid-template-rows: auto 1fr;
  background-color: white;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  border-radius: 5px;
  min-width: ${({ minWidth }) => minWidth}px;
  min-height: ${({ minHeight }) => minHeight}px;
  max-width: ${props => getWidth(props)};
  max-height: ${props => (props.maxHeight ? getHeight(props) : '830px')};
  ${props => (props.size === 'fullscreen' ? 'height:' + getHeight(props) : 'height: auto')};
  ${props => (props.size === 'fullscreen' ? 'width:' + getWidth(props) : 'width: auto')};
  overflow: ${({ overflow }) => overflow};
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0px 20px 0 rgba(0, 0, 0, 0.2);

  @media screen and (max-width: 576px) {
    width: 90vw;
  }
`;

export const HeaderElement = styled.div<{ variation: ModalVariation; subHeader: boolean }>`
  display: flex;
  justify-content: space-between;
  z-index: 1;
  padding: 0 24px 22px 24px;
  border-bottom: ${({ variation }) => (variation === 'clean' ? 'none' : '1px solid rgba(0, 0, 0, 0.05)')};
  box-shadow: ${({ variation }) => (variation === 'clean' ? 'none' : '0px 5px 15px 0px rgba(0, 0, 0, 0.03)')};

  flex-direction: ${({ subHeader }) => (subHeader ? 'column' : 'row')};
  align-items: ${({ subHeader }) => (subHeader ? 'flex-start' : 'center')};
`;

export const HeaderContentElement = styled.div`
  font-size: 24px;
  font-weight: 600;
`;

export const HeaderButtonElement = styled.div`
  margin-right: 5px;
`;

export const SubHeader = styled.div`
  font: ${({ theme }) => theme.designToken.body1};
  margin-top: ${({ theme }) => theme.designToken.spacing3};
`;
export const HeaderTop = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;

export const ContentElement = styled.div<{ overflow: string }>`
  margin: 0px;
  padding: 0 24px;
  overflow: ${({ overflow }) => overflow};
  position: relative;

  ::-webkit-scrollbar {
    background-color: transparent;
    height: 8px;
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => rgba(theme.vars.newColor.black, 0.5)};
    border-radius: 8px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const FooterElement = styled.div<{
  variation: ModalVariation;
  centerButtons: boolean;
  overflowVisible: boolean;
  footerAlert: JSX.Element;
}>`
  display: flex;
  z-index: ${({ overflowVisible }) => (!overflowVisible ? 1 : null)};
  justify-content: ${({ centerButtons }) => (centerButtons ? 'center' : 'flex-start')};
  padding: 22px 24px 0 24px;
  border-top: ${({ variation }) => (variation === 'clean' ? 'none' : '1px solid rgba(0, 0, 0, 0.05)')};
  box-shadow: ${({ variation }) => (variation === 'clean' ? 'none' : '0px -5px 15px 0px rgba(0, 0, 0, 0.03)')};
  align-items: ${({ footerAlert }) => (footerAlert ? 'flex-start' : 'center')};
  flex-direction: ${({ footerAlert }) => (footerAlert ? 'column' : 'row')};
`;

export const FooterAlert = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.designToken.spacing3};
  margin-bottom: ${({ theme }) => theme.designToken.spacing4};
`;

export const CustomFooterElement = styled.div`
  margin-left: 20px;
`;

function getWidth(props: IProps) {
  switch (props.size) {
    case 'small':
      return '400px';
    case 'medium':
    default:
      return '600px';
    case 'large':
      return '90vw';
    case 'tall':
      return '500px';
    case 'wide':
      return '80vw';
    case 'fullscreen':
      return '90vw';
  }
}

function getHeight(props: IProps) {
  switch (props.size) {
    case 'small':
      return '40vh';
    case 'medium':
    default:
      return '60vh';
    case 'large':
      return '90vh';
    case 'tall':
      return '80vh';
    case 'wide':
      return '60vh';
    case 'fullscreen':
      return '90vh';
  }
}
